import { isTablet, isMobile } from "react-device-detect";

const getNewAction = (templateId, currentPageId) =>{
  let action = '';
  if (templateId != "CONGRATULATIONS_PAGE" &&
      templateId != "4G-CONTACT-OPTIONS-WITHOUT-REPAIR" &&
      templateId != "4G-CONTACT-OPTIONS-WITH-REPAIR" &&
      currentPageId > 1) {
      action = "TRG_SIGNIN_4G_PROGRESS"
      if (window.config?.isLoggedOut) {
          action = "TRG_NONSIGNIN_4G_PROGRESS"
      }
    }else if ((templateId == "4G-CONTACT-OPTIONS-WITH-REPAIR" ||
      templateId == "4G-CONTACT-OPTIONS-WITHOUT-REPAIR") &&
      currentPageId > 1) {
      action = "TRG_SIGNIN_4G_CONTACT_US"
      if (window.config?.isLoggedOut) {
        action = "TRG_NONSIGNIN_4G_CONTACT_US"
      }
    }else if (templateId == "CONGRATULATIONS_PAGE" &&
      currentPageId > 1) {
      action = "TRG_SIGNIN_4G_COMPLETED"
      if (window.config?.isLoggedOut) {
        action = "TRG_NONSIGNIN_4G_COMPLETED"
      }
    }
  return action;
}
 /* istanbul ignore next */
const common = {

  getChannelId: function (sURL) {
    let channelID = "";
    if (window.config?.channelId) {
      channelID = window.config?.channelId;
      if (channelID == "VZW-DOTCOM" && isMobile) {
        channelID = "VZW-DOTCOM-MOB";
      }
    } else if (window.location.pathname.toLowerCase().indexOf("/mva") > -1) {
      channelID = "VZW-MFA";
    } else {
      if (isMobile) {
        channelID = "VZW-DOTCOM-MOB";
      } else {
        channelID = "VZW-DOTCOM";
      }
    }
    return channelID;
  },

  // below method is returning channel id and intent from casedetails object from window
  getCaseChannelDetails: function (sURL) {
    let channelID = "";
    if (typeof window.caseDetails?.channel !== "undefined" && window.caseDetails?.channel !== null) {
      if ((window.caseDetails?.channel == "My Verizon" || window.caseDetails?.channel == "Verizon website") && isMobile) {
        channelID = "VZW-DOTCOM-MOB"
      } else if ((window.caseDetails?.channel == "My Verizon" || window.caseDetails?.channel == "Verizon website") && isTablet) {
        channelID = "VZW-DOTCOM-TAB"
      } else {
        channelID = "VZW-DOTCOM"
      }
    } 
    return { channelID, flowName: JSON.stringify({ intentType: window?.caseDetails?.intent ?? "", devicename: window?.troubleShootingJson?.ddata?.device?.soeUrl ?? "" }) };
  },

  getAction: function (interfaceName, clickstream, templateId, currentPageId) {
    let action = "TRG_SIGNIN_4G_PAGELOAD"
    if (window.config?.isLoggedOut) {
      action = "TRG_NONSIGNIN_4G_PAGELOAD"
    }

    if (interfaceName == "PAGE-LOADED" && clickstream == "PAGE-LOADED" && templateId && currentPageId) {
      action = getNewAction(templateId, currentPageId);
    } else if (clickstream != "PAGE-LOADED" && interfaceName != "PAGE-LOADED") {
      action = clickstream.replace(/[{}]/g, '') + " click"
    }
    
    return action
  },

  getErrorMessage: function (error) {
    let errorMsg = "";
    try {
      if (error !== null && error.error !== null) {
        if (error.status === 200 && error.error.error !== null)
          errorMsg =
            error.error.error.message !== null
              ? error.error.error.message
              : JSON.stringify(error.error.error);
        else errorMsg = JSON.stringify(error.error);
      } 
      if (error.status !== null) errorMsg += `STATUS=${error.status},`;
      if (error.message !== null) errorMsg += `MSG=${error.message}`;
      if (errorMsg === "") errorMsg = JSON.stringify(error);
    } catch (ex) {
      errorMsg = JSON.stringify(error);
    }
    return errorMsg;
  },

  loadUtagScript(callback) {
    const existingScript = document.getElementById('vzta');
    let tagUrl = window.config?._vzwTagUrl;
    if (!existingScript && tagUrl) {
      const script = document.createElement('script');
      script.src = tagUrl;
      script.id = 'vzta';
      document.body.appendChild(script);
      script.onload = () => {
        if (callback) callback();
      };
    }
    if (existingScript && callback) callback();
  },

  stringifyJSON(obj) {
    try {
      if (obj && obj !== null && obj !== "") {
        if (typeof obj === "string") {
          return obj;
        } else {
          return JSON.stringify(obj);
        }
      }
    } catch (e) { }
    return obj;
  },

};

export default common;
